import { useEffect } from "react";
import useHttpUtility from "../utilities/useHttpUtility";
import useFormUtility from "../utilities/useFormUtility";
import Cards from "../components/Cards";
import Card from "../components/Card";
import LoadingScreen from "../components/LoadingScreen";

export default function PageSettingsThemes() {

    const http = useHttpUtility();
    const formUtility = useFormUtility(null);

    useEffect(() => {
        http.get("/api/Themes", formUtility.setData);
    }, []);

    async function handleWidgetInstall(theme) {
        await http.post(`/api/Themes/${theme.id}/Widgets/Install`, null);
    }

    return (!formUtility.data
        ? <LoadingScreen isFullScreen={false} />
        :
        <div className="page page-settings-themes">
            <Cards>
                {
                    formUtility.data.map(d =>
                        <Card title={d.name}>
                            <div onClick={() => handleWidgetInstall(d)}>Install Widget</div>
                        </Card>
                    )
                }
            </Cards>
        </div>
    );
}